module.exports = `${require.publicPath}sby-logo-sm.757406f6.webp`;